export default {
	isOpen: false,
	isInTransition: false,
	positionV: 'bottom',
	tabIndex: 1,
	onBlur() {},
	onClick() {},
	onFocus() {},
	onKeyDown() {},
	onKeyUp() {},
	onMouseDown() {},
	onMouseEnter() {},
	onMouseLeave() {},
	onMouseUp() {},
	onTouchEnd() {},
	onTouchStart() {},
};



/** WEBPACK FOOTER **
 ** ./src/components/bubble-list-item/bubble-list-item.default-props.js
 **/